import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';

export const TextCostIndicator = styled(Text, {
  dynamic: ({
    cssProps: { isGroupedLocationDrawer, costUnavailable } = {},
  }) => ({
    '&.abyss-text-root': {
      color:
        isGroupedLocationDrawer && costUnavailable && '$core.color.neutral.80',
      fontStyle: 'normal',
      fontWeight:
        isGroupedLocationDrawer && costUnavailable
          ? '400 !important'
          : '700 !important',
      letterSpacing: '1.5px',
      '@media (min-width: 745px)': {
        fontSize: '18px',
        lineHeight: '24px' /* 133.333% */,
      },
      '@media (max-width: 744px)': {
        fontSize: '12.64px',
        lineHeight: '16px' /* 126.582% */,
      },
    },
  }),
});

export const BelowAverageTextColor = {
  color: '$core.color.green.100', // Hex: #007000
};

export const AverageTextColor = {
  color: '#0248AC', // Blue
};

export const AboveAverageTextColor = {
  color: '#AA2E23', // red
};

export const PDFTextColor = {
  color: '#333333', // #929496
};

export const DefaultTextColor = {
  color: '#929496', // #929496
};
